import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import { unsubscribePrelaunch } from '../services/auth';

/**
 * Désinscription de la liste de pré-ouverture depuis le lien des emails.
 * Le destinataire n'ayant pas de compte, ce lien est sa seule façon de
 * demander la suppression de sa demande.
 */
export default function Unsubscribe() {
  const { t } = useTranslation('auth');
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }

    unsubscribePrelaunch(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center space-y-6">
        <div className="flex justify-center">
          <div className="px-6 py-3 rounded-full flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-600">
            <span className="text-white text-2xl font-bold">Splinity</span>
          </div>
        </div>

        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 text-primary-500 animate-spin mx-auto" />
            <p className="text-gray-600">{t('unsubscribe.loading')}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto" />
            <h1 className="text-2xl font-bold text-gray-900">{t('unsubscribe.doneTitle')}</h1>
            <p className="text-gray-600">{t('unsubscribe.doneMessage')}</p>
            <p className="text-sm text-gray-500">{t('unsubscribe.comeBack')}</p>
          </>
        )}

        {status === 'error' && (
          <>
            <AlertCircle className="w-16 h-16 text-red-500 mx-auto" />
            <h1 className="text-2xl font-bold text-gray-900">{t('unsubscribe.errorTitle')}</h1>
            <p className="text-gray-600">{t('unsubscribe.errorMessage')}</p>
          </>
        )}

        <Link
          to="/"
          className="inline-block mt-4 text-primary-600 hover:text-primary-700 font-medium"
        >
          {t('unsubscribe.backHome')}
        </Link>
      </div>
    </div>
  );
}
